export enum StudyTabEnum {
    Draft = 'Draft',
    InProgress = 'In Progress',
    Posted = 'Posted',
    Cancelled = 'Cancelled',
}
